import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './AuthError.scss';

/**
 * Authentication Error control
 * @class AuthError
 * @extends {Component}
 */
class AuthError extends Component {
  static propTypes = {
    /** Header image */
    headerImage: PropTypes.string,
    /** Header title */
    headerTitle: PropTypes.string,
    /** Header description */
    headerDescription: PropTypes.string,
    /** Text displayed on the accept button. */
    acceptText: PropTypes.string,
    /** Function executed when ok button is clicked. */
    onAcceptClick: PropTypes.func,
    /** The text that will be displayed in the link. */
    linkText: PropTypes.string,
    /** Function executed when the link is clicked. */
    onLinkClick: PropTypes.func,
    /** The DOM tree/component to be used for the footer */
    footer: PropTypes.object,
  };
  static defaultProps = {
    headerImage: './alert.png',
    headerTitle: 'Sorry',
    headerDescription: 'There is a problem. Contact your help desk.',
    acceptText: 'OK',
  };
  render() {
    return (
      <div className='login-container'>
        <div className='form-group login-header'>
          <img src={this.props.headerImage}
            id='AuthError_header_image'
            className='header-image'
            alt='Authentication Error'
          />
          <h2 id='AuthError_header_title'
            className='header-title'
          >
            {this.props.headerTitle}
          </h2>
          <div id='AuthError_header_description'
            className='header-description'
          >
            {this.props.headerDescription}
          </div>
        </div>
        { this.props.acceptText &&
        <div className='form-group text-center'>
          <button id='AuthError_accept_button'
            className='btn btn-primary'
            onClick={this.props.onAcceptClick}
          >
            {this.props.acceptText}
          </button>
        </div>
        }
        { this.props.linkText &&
        <div className='form-group text-center'>
          {
            // eslint-disable-next-line
          }<a id='AuthError_link'
            className='btn btn-link'
            onClick={this.props.onLinkClick}
          >
            {this.props.linkText}
          </a>
        </div>
        }
        { this.props.footer }
      </div>
    );
  }
}

export default AuthError;
